import api from "@utils/api";

export const getOrganizations = (page, perPage) =>
  api.get(`/organizaciones/?page=${page}&per_page=${perPage}`);

export const createOrganization = (data) => api.post(`/organizaciones/`, data);

export const getOrganizationById = (id) => api.get(`/organizaciones/${id}`);

export const updateOrganization = (id, data) => api.put(`/organizaciones/${id}`, data);

export const deleteOrganization = (id) => api.delete(`/organizaciones/${id}`);

export const getPagesByOrganization = (orgId) => api.get(`/organizaciones/pages/${orgId}`);